"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCubby = exports.useClosestBooking = exports.VideoChatCubbyScreenTitles = exports.VideoChatCubbyScreen = exports.NoteSectionStatus = void 0;
var _lodash = require("lodash");
var _react = require("react");
var _utils = require("../../utils");
var _types = require("../../types");
var _ = require("./..");
var _VideoChatCubbyScreen, _DefaultSectionStatus;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var POLLING_INTERVAL_MS = 10000;
var groupQuestionsBySortedSection = function groupQuestionsBySortedSection(questions) {
  if (!questions) {
    return {};
  }
  var grouped = (0, _lodash.groupBy)(questions, function (question) {
    var _question$surveySecti;
    return (_question$surveySecti = question.surveySection) === null || _question$surveySecti === void 0 ? void 0 : _question$surveySecti.name;
  });
  var orderedKeys = (0, _lodash.sortBy)((0, _lodash.keys)(grouped), function (key) {
    return grouped[key][0].order;
  });
  var orderedGrouped = {};
  orderedKeys.forEach(function (key) {
    orderedGrouped[key] = grouped[key];
  });
  return orderedGrouped;
};
var VideoChatCubbyScreen = /*#__PURE__*/function (VideoChatCubbyScreen) {
  VideoChatCubbyScreen["SectionIndex"] = "section-index";
  VideoChatCubbyScreen["Patient"] = "patient";
  VideoChatCubbyScreen["Notes"] = "notes";
  VideoChatCubbyScreen["Billing"] = "billing";
  VideoChatCubbyScreen["Prescriptions"] = "prescriptions";
  return VideoChatCubbyScreen;
}({});
exports.VideoChatCubbyScreen = VideoChatCubbyScreen;
var VideoChatCubbyScreenTitles = (_VideoChatCubbyScreen = {}, _defineProperty(_VideoChatCubbyScreen, VideoChatCubbyScreen.Patient, 'Patient'), _defineProperty(_VideoChatCubbyScreen, VideoChatCubbyScreen.Notes, 'Notes'), _defineProperty(_VideoChatCubbyScreen, VideoChatCubbyScreen.Billing, 'Billing'), _defineProperty(_VideoChatCubbyScreen, VideoChatCubbyScreen.Prescriptions, 'Prescriptions'), _VideoChatCubbyScreen);
exports.VideoChatCubbyScreenTitles = VideoChatCubbyScreenTitles;
var NoteSectionStatus = /*#__PURE__*/function (NoteSectionStatus) {
  NoteSectionStatus["Incomplete"] = "Incomplete";
  NoteSectionStatus["Complete"] = "Complete";
  return NoteSectionStatus;
}({});
exports.NoteSectionStatus = NoteSectionStatus;
var DefaultSectionStatuses = (_DefaultSectionStatus = {}, _defineProperty(_DefaultSectionStatus, VideoChatCubbyScreen.Notes, NoteSectionStatus.Incomplete), _defineProperty(_DefaultSectionStatus, VideoChatCubbyScreen.Billing, NoteSectionStatus.Incomplete), _DefaultSectionStatus);
var getInitialStatusesFromNote = function getInitialStatusesFromNote(data) {
  var _newStatuses;
  var newStatuses = (_newStatuses = {}, _defineProperty(_newStatuses, VideoChatCubbyScreen.Notes, !data.soap || data.soap.status !== _types.SessionNoteStatus.Submitted ? NoteSectionStatus.Incomplete : NoteSectionStatus.Complete), _defineProperty(_newStatuses, VideoChatCubbyScreen.Billing, !data.billingCode || data.billingCode.status !== _types.SessionNoteStatus.Submitted ? NoteSectionStatus.Incomplete : NoteSectionStatus.Complete), _newStatuses);
  return newStatuses;
};
var formatSessionNoteForCubby = function formatSessionNoteForCubby(note) {
  var _note$billingCode, _note$billingCode2, _note$soap, _note$soap2, _note$soap3, _note$soap4, _note$soap5, _note$soap6, _note$soap7, _note$billingCode3;
  if (!note) {
    return {};
  }
  return {
    icdCodes: ((_note$billingCode = note.billingCode) === null || _note$billingCode === void 0 ? void 0 : _note$billingCode.icdCodes) || [],
    posCode: ((_note$billingCode2 = note.billingCode) === null || _note$billingCode2 === void 0 ? void 0 : _note$billingCode2.posCode) || _utils.PosCode.Home,
    subjective: (_note$soap = note.soap) === null || _note$soap === void 0 ? void 0 : _note$soap.subjective,
    objective: (_note$soap2 = note.soap) === null || _note$soap2 === void 0 ? void 0 : _note$soap2.objective,
    assessment: (_note$soap3 = note.soap) === null || _note$soap3 === void 0 ? void 0 : _note$soap3.assessment,
    plan: (_note$soap4 = note.soap) === null || _note$soap4 === void 0 ? void 0 : _note$soap4.plan,
    additionalNotes: (_note$soap5 = note.soap) === null || _note$soap5 === void 0 ? void 0 : _note$soap5.additionalNotes,
    canEditSubjective: (_note$soap6 = note.soap) === null || _note$soap6 === void 0 ? void 0 : _note$soap6.canEditSubjective,
    soapStatus: (_note$soap7 = note.soap) === null || _note$soap7 === void 0 ? void 0 : _note$soap7.status,
    billingCodeStatus: (_note$billingCode3 = note.billingCode) === null || _note$billingCode3 === void 0 ? void 0 : _note$billingCode3.status
  };
};
var useSessionNote = function useSessionNote(_ref) {
  var booking = _ref.booking,
    onGetNote = _ref.onGetNote;
  var _useAuth = (0, _.useAuth)(),
    user = _useAuth.user;
  var _useState = (0, _react.useState)({}),
    _useState2 = _slicedToArray(_useState, 2),
    newNote = _useState2[0],
    setNewNote = _useState2[1];
  var _useRequest = (0, _utils.useRequest)(function (bookingId) {
      return {
        url: (0, _utils.getSessionNotesUrl)(user.accountId),
        method: 'post',
        data: {
          bookingId: bookingId
        }
      };
    }, {
      manual: true,
      onSuccess: function onSuccess(data) {
        var formattedNote = formatSessionNoteForCubby(data);
        setNewNote(formattedNote);
        onGetNote(data);
      }
    }),
    getNoteForBooking = _useRequest.runAsync,
    refreshNote = _useRequest.refreshAsync,
    loadingGetNote = _useRequest.loading;
  var _useRequest2 = (0, _utils.useRequest)(function (bookingId, note) {
      return {
        url: (0, _utils.getSessionNotesUrl)(user.accountId, bookingId),
        method: 'patch',
        data: note
      };
    }, {
      manual: true,
      onError: function onError() {
        _utils.toast.error({
          title: 'Error submitting session note'
        });
      }
    }),
    _updateNote = _useRequest2.runAsync;
  var updateNoteDebounced = (0, _react.useCallback)((0, _lodash.debounce)(function (bookingId, note) {
    _updateNote(bookingId, _objectSpread(_objectSpread({}, note), {}, {
      // Making changes to note should mark it as draft again
      soapStatus: _types.SessionNoteStatus.Draft,
      billingCodeStatus: _types.SessionNoteStatus.Draft
    }));
  }, 1000), []);
  (0, _react.useEffect)(function () {
    if (booking && (0, _lodash.isEmpty)(newNote)) {
      getNoteForBooking(booking.id);
    }
    if (booking && !(0, _lodash.isEmpty)(newNote)) {
      updateNoteDebounced(booking.id, newNote);
    }
  }, [booking, newNote]);
  return {
    newNote: newNote,
    setNewNote: setNewNote,
    loadingGetNote: loadingGetNote,
    updateNote: function () {
      var _updateNote2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(values) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!booking) {
                  _context.next = 3;
                  break;
                }
                _context.next = 3;
                return _updateNote(booking.id, values);
              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      function updateNote(_x) {
        return _updateNote2.apply(this, arguments);
      }
      return updateNote;
    }(),
    refreshNote: refreshNote
  };
};
var usePollForUpdates = function usePollForUpdates(_ref2) {
  var service = _ref2.service,
    compareFn = _ref2.compareFn,
    toastMessage = _ref2.toastMessage,
    _ref2$onUpdate = _ref2.onUpdate,
    onUpdate = _ref2$onUpdate === void 0 ? _lodash.noop : _ref2$onUpdate;
  var _useState3 = (0, _react.useState)(0),
    _useState4 = _slicedToArray(_useState3, 2),
    numRequests = _useState4[0],
    setNumRequests = _useState4[1];
  // State used to compare request data. If data has changed, show toast
  var _useState5 = (0, _react.useState)(),
    _useState6 = _slicedToArray(_useState5, 2),
    requestData = _useState6[0],
    setRequestData = _useState6[1];
  var _useRequest3 = (0, _utils.useRequest)(service, {
      manual: true,
      pollingInterval: POLLING_INTERVAL_MS,
      onBefore: function onBefore() {
        setNumRequests(function (prev) {
          return prev + 1;
        });
        setRequestData(compareFn(data));
      },
      onSuccess: function onSuccess() {
        var newData = compareFn(data);
        if (numRequests > 1 && requestData !== newData) {
          _utils.toast.success({
            title: toastMessage
          });
          onUpdate(data);
        }
      }
    }),
    data = _useRequest3.data,
    startPolling = _useRequest3.runAsync,
    cancel = _useRequest3.cancel,
    loading = _useRequest3.loading;
  var cancelPolling = function cancelPolling() {
    cancel();
    setNumRequests(0);
  };
  return {
    // Since this request will be polling, we only want to show loading state on first load
    loading: loading && numRequests <= 1,
    data: data,
    startPolling: startPolling,
    cancelPolling: cancelPolling
  };
};

/**
 * It's possible that the patient updates their intake while
 * the clinician is on a video call or views a session note,
 * so we set up polling to retrieve the intake as it updates
 */
var useIntake = function useIntake(booking) {
  var _usePollForUpdates = usePollForUpdates({
      service: function service(patientId) {
        return (0, _utils.getPatientSurveyAnswersUrl)({
          patientId: patientId,
          surveyType: _types.SurveyTypesEnum.Intake,
          surveyStatuses: [_types.SurveyStatuses.Ongoing, _types.SurveyStatuses.Finished]
        });
      },
      compareFn: function compareFn(patientSurvey) {
        var _patientSurvey$patien;
        return JSON.stringify(patientSurvey === null || patientSurvey === void 0 ? void 0 : (_patientSurvey$patien = patientSurvey.patientAnswers) === null || _patientSurvey$patien === void 0 ? void 0 : _patientSurvey$patien.map(function (x) {
          return {
            questionId: x.questionId,
            answer: x.answer
          };
        }));
      },
      toastMessage: 'Patient updated intake answers'
    }),
    patientSurvey = _usePollForUpdates.data,
    loading = _usePollForUpdates.loading,
    startPolling = _usePollForUpdates.startPolling,
    cancelPolling = _usePollForUpdates.cancelPolling;
  var survey = (0, _react.useMemo)(function () {
    var _patientSurvey$survey;
    if (!patientSurvey) {
      return null;
    }
    var targetSurveyWithSections = _objectSpread(_objectSpread({
      updatedAt: patientSurvey.updatedAt
    }, patientSurvey.survey), {}, {
      sections: groupQuestionsBySortedSection((_patientSurvey$survey = patientSurvey.survey) === null || _patientSurvey$survey === void 0 ? void 0 : _patientSurvey$survey.questions)
    });
    return targetSurveyWithSections;
  }, [patientSurvey, loading]);
  (0, _react.useEffect)(function () {
    if (booking) {
      startPolling(booking.patientId);
    }
    return cancelPolling;
  }, [booking]);
  return {
    // Since this request will be polling, we only want to show loading state on first load
    loadingIntakeSurvey: loading,
    intakeSurvey: survey,
    patientAnswers: patientSurvey === null || patientSurvey === void 0 ? void 0 : patientSurvey.patientAnswers
  };
};

/**
 * It's possible that the patient updates their profile while
 * the clinician is on a video call or views a session note,
 * so we set up polling to retrieve the intake as it updates.
 * To simplify the code, we only poll for a complete patient profile
 * during video calls for now.
 */
var useIncompletePatientProfile = function useIncompletePatientProfile(patient) {
  // useVideoChat values are undefined in admin app b/c VideoChatContext is not rendered
  var _useVideoChat = (0, _.useVideoChat)(),
    _useVideoChat$setTarg = _useVideoChat.setTarget,
    setTarget = _useVideoChat$setTarg === void 0 ? _lodash.noop : _useVideoChat$setTarg,
    isVideoActive = _useVideoChat.isVideoActive;
  var _usePollForUpdates2 = usePollForUpdates({
      service: function service(patientId) {
        return (0, _utils.getPatientProfileUrl)(patientId);
      },
      compareFn: function compareFn(data) {
        return JSON.stringify((0, _lodash.pick)(data, ['firstName', 'lastName', 'birthDate', 'sex', 'preferredName', 'pronoun', 'phoneNumber']));
      },
      toastMessage: 'Patient updated their profile',
      onUpdate: function onUpdate(data) {
        if (isVideoActive) {
          setTarget(function (prevTarget) {
            return _objectSpread(_objectSpread({}, prevTarget), data);
          });
        }
      }
    }),
    startPolling = _usePollForUpdates2.startPolling,
    cancelPolling = _usePollForUpdates2.cancelPolling;
  (0, _react.useEffect)(function () {
    if (patient !== null && patient !== void 0 && patient.id && isVideoActive) {
      startPolling(patient.id);
    }
    return cancelPolling;
  }, [patient === null || patient === void 0 ? void 0 : patient.id, isVideoActive]);
};
var useClosestBooking = function useClosestBooking() {
  var _useAuth2 = (0, _.useAuth)(),
    user = _useAuth2.user;
  var _useRequest4 = (0, _utils.useRequest)(function (patientId) {
      return (0, _utils.getCloseBookingUrl)(user.accountId, patientId);
    }, {
      manual: true
    }),
    closestBooking = _useRequest4.data,
    getClosestBooking = _useRequest4.runAsync,
    loadingClosestBooking = _useRequest4.loading;
  return {
    closestBooking: closestBooking,
    getClosestBooking: getClosestBooking,
    loadingClosestBooking: loadingClosestBooking
  };
};
exports.useClosestBooking = useClosestBooking;
var useCubby = function useCubby(_ref3) {
  var patient = _ref3.patient,
    booking = _ref3.booking,
    initialScreen = _ref3.initialScreen;
  var _useAuth3 = (0, _.useAuth)(),
    user = _useAuth3.user;
  var _useState7 = (0, _react.useState)(initialScreen),
    _useState8 = _slicedToArray(_useState7, 2),
    currentScreen = _useState8[0],
    setCurrentScreen = _useState8[1];
  var screens = [VideoChatCubbyScreen.Patient, VideoChatCubbyScreen.Prescriptions, VideoChatCubbyScreen.Notes, VideoChatCubbyScreen.Billing];
  var _useState9 = (0, _react.useState)(DefaultSectionStatuses),
    _useState10 = _slicedToArray(_useState9, 2),
    sectionStatuses = _useState10[0],
    setSectionStatuses = _useState10[1];
  var sessionNoteProps = useSessionNote({
    booking: booking,
    onGetNote: function onGetNote(data) {
      setSectionStatuses(function (statuses) {
        return _objectSpread(_objectSpread({}, statuses), getInitialStatusesFromNote(data));
      });
    }
  });
  var intakeProps = useIntake(booking);
  useIncompletePatientProfile(patient);
  var onGoToScreen = function onGoToScreen(screen) {
    setCurrentScreen(screen);
  };
  var onSetStatus = function onSetStatus(screen, status) {
    setSectionStatuses(function (statuses) {
      return _objectSpread(_objectSpread({}, statuses), {}, _defineProperty({}, screen, status));
    });
  };
  return _objectSpread(_objectSpread({
    readonly: (user === null || user === void 0 ? void 0 : user.accountId) !== (booking === null || booking === void 0 ? void 0 : booking.clinicianId),
    currentScreen: currentScreen,
    screens: screens,
    sectionStatuses: sectionStatuses,
    onGoToScreen: onGoToScreen,
    onSetStatus: onSetStatus
  }, sessionNoteProps), intakeProps);
};
exports.useCubby = useCubby;